module.exports = __webpack_public_path__ + "static/media/article-cover-pending.5ce3b356.png";